// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"d56f2d5f","243":"d56f2d5f","411":"d56f2d5f","699":"d56f2d5f","715":"d56f2d5f","774":"a26f33a9"}[chunkId] + ".chunk.css";
};